import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";

class DonateNow extends Component {
  render() {
    return (
      <div>
        <NavBar />

        {/* Breadcrumb */}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Donate Now</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>Donate Now</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Donation Details */}
        <div className="page-wrapper section-space--inner--120">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div
                  className="p-5 shadow-sm"
                  style={{
                    background: "#fff",
                    borderRadius: "10px"
                  }}
                >
                  <h2 className="text-center mb-4">
                    Support Our Mission
                  </h2>

                  <p className="text-center mb-5">
                    Your contribution helps us continue our work and make a
                    positive impact.
                  </p>

                  <div className="donation-details">
                    <h4>Bank Account Details</h4>

                    <ul className="list-unstyled mt-4">
                      <li>
                        <strong>Account Name:</strong> Shakuntla Learn and Fly Foundation
                      </li>
                      <li>
                        <strong>Bank Name:</strong> Punjab National Bank
                      </li>
                      <li>
                        <strong>Account Number:</strong> 3145002100019828
                      </li>
                      <li>
                        <strong>IFSC Code:</strong> PUNB0314500
                      </li>
                      <li>
                        <strong>Branch:</strong> SUKHRALI (Gurgaon) Haryana-122028
                      </li>
                    </ul>

                    <div className="mt-4">
                      <p>
                        After making your donation, please send the payment
                        details to:
                      </p>
                      <strong>Email:</strong> info@shakuntlafoundation.org
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <MobileMenu />
      </div>
    );
  }
}

export default DonateNow;